import { render, staticRenderFns } from "./TrueFalse.vue?vue&type=template&id=17144747&scoped=true&"
import script from "./TrueFalse.vue?vue&type=script&lang=js&"
export * from "./TrueFalse.vue?vue&type=script&lang=js&"
import style0 from "./TrueFalse.vue?vue&type=style&index=0&id=17144747&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17144747",
  null
  
)

export default component.exports